import React from 'react';
import { getQueryVariable } from '../../../utils';
import { Login } from './Login';
import { User } from 'oidc-client';
import { AuthService } from '../../../services';

interface LoginContainerState {
  loggingIn: boolean;
  referrer?: string;
  user?: User;
  pwdiUser?: User;
}

export class LoginContainer extends React.Component<{}, LoginContainerState> {
  state = {
    referrer: undefined,
    loggingIn: false,
    user: undefined,
    pwdiUser: undefined,
  };

  componentDidMount() {
    AuthService.onSigningIn = () => this.setState({ loggingIn: true });
    AuthService.onSignedIn = async (success: boolean) => {
      if (success) {
        this.setState({
          user: await AuthService.getUser(),
          pwdiUser: await AuthService.getUser('pwdi'),
          loggingIn: false,
        });
      } else {
        this.setState({ loggingIn: false });
      }
    };
    this.setState({ referrer: getQueryVariable('referrer') });
  }

  componentWillUnMount() {
    AuthService.onSigningIn = () => {};
    AuthService.onSignedIn = async () => {};
  }

  render() {
    return this.state.referrer ? (
      <Login
        user={this.state.user}
        pwdiUser={this.state.pwdiUser}
        loggingIn={this.state.loggingIn}
        login={() => AuthService.signin()}
        referrer={getQueryVariable('referrer')}
      />
    ) : null;
  }
}
